// Loaders for the pages AuthWall shows around sign-in (#12239).
//
// Most visits never render them (a signed-in user goes straight to the app),
// and they carry the Stytch client, so each loads on demand instead of riding
// in the entry script. `components/MainApp/routeModules.test.ts` awaits every
// entry, so a wrong path fails a test rather than a sign-in.
export const authRouteModules = {
  LogOut: () => import("./components/LogOut"),
  StytchTokenLogin: () =>
    import("./components/Authentication/StytchTokenLogin"),
  LogInB2C: () => import("./components/Authentication/LogInB2C"),
  OAuthAuthorize: () => import("./components/Authentication/OAuthAuthorize"),
  OAuthAuthorizeB2B: () =>
    import("./components/Authentication/OAuthAuthorizeB2B"),
  OAuthPick: () => import("./components/Authentication/OAuthPick"),
  McpConnectorComplete: () =>
    import("./components/Authentication/McpConnectorComplete"),
  ResetB2C: () => import("./components/Authentication/ResetB2C"),
  VerifyEmail: () => import("./components/Authentication/VerifyEmail"),
  SecureLinkPage: () => import("./components/SecureLink/SecureLinkPage"),
  OneNoteCallBackPage: () =>
    import("./components/OneNoteViewer/OneNoteCallBackPage"),
};
